// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1twK-","load8":"Spinner_load8__36vjM","center":"Spinner_center__2vn5M"};